import type { ComponentProps, ReactNode } from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from './tooltip';

type TooltipFlatProps = {
  children: ReactNode;
  triggerClassName?: string;
  content: ReactNode;
  contentClassName?: string;
  asChild?: boolean;
  side?: ComponentProps<typeof TooltipContent>['side'];
};

export const TooltipFlat = ({
  children,
  triggerClassName,
  asChild,
  content,
  contentClassName,
  side,
}: TooltipFlatProps) => {
  return (
    <Tooltip>
      <TooltipTrigger className={triggerClassName} asChild={asChild}>
        {children}
      </TooltipTrigger>
      <TooltipContent className={contentClassName} side={side}>
        {content}
      </TooltipContent>
    </Tooltip>
  );
};
